module.exports = __webpack_public_path__ + "static/media/searchIcon.7d4dd9b6.png";